import React from 'react';

export function Field({ label, hint, children, htmlFor, error }) {
  return (
    <div className="space-y-1.5">
      <label htmlFor={htmlFor} className="block text-sm font-medium text-slate-700">{label}</label>
      {children}
      {hint && !error && <p className="text-xs text-slate-500">{hint}</p>}
      {error && <p className="text-xs text-rose-600" role="alert">{error}</p>}
    </div>
  );
}

export const inputClass =
  "w-full h-11 px-3.5 rounded-lg border border-slate-200 bg-white text-slate-900 placeholder:text-slate-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:border-emerald-500 transition-shadow";

export const selectClass = inputClass + " appearance-none pr-9 bg-no-repeat bg-[right_0.75rem_center] bg-[url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2216%22 height=%2216%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%2394a3b8%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22><polyline points=%226 9 12 15 18 9%22/></svg>')]";

export function ResultRow({ label, value, primary = false, mono = false, testId }) {
  return (
    <div className={`flex items-baseline justify-between gap-4 py-2 ${primary ? 'border-t border-slate-200 pt-3 mt-1' : ''}`}>
      <span className={`text-sm ${primary ? 'text-slate-900 font-semibold' : 'text-slate-500'}`}>{label}</span>
      <span
        data-testid={testId}
        className={`${primary ? 'text-2xl sm:text-3xl font-bold text-emerald-700' : 'text-base font-medium text-slate-900'} ${mono ? 'font-mono' : ''}`}
      >{value}</span>
    </div>
  );
}
